import { Toolbar, GridToolbarProps } from '@mui/x-data-grid-premium';
import { Stack } from '@mui/material';
import { ToggleSwitch } from '@retail/components';

interface Props extends GridToolbarProps {
  showSuperuser: boolean;
  setShowSuperuser: (show: boolean) => void;
}

export const TableToolbar = ({ showSuperuser, setShowSuperuser, ...props }: Props) => {
  return (
    <Toolbar {...props}>
      <Stack direction="row" spacing={2} alignItems="center" sx={{ padding: 1 }}>
        <ToggleSwitch
          setToggle={setShowSuperuser}
          toggle={showSuperuser}
          text="Include SUPERUSER permissions"
        />
      </Stack>
    </Toolbar>
  );
};
